<template>
    <div class="ui-pills" role="tablist">
        <button v-for="item in items" :key="String(item.value)" type="button" role="tab" class="ui-pill"
            :class="{ 'ui-pill--active': item.value === value }" :aria-selected="item.value === value" @click="$emit('input', item.value)">
            <span v-if="item.tone" class="ui-pill__dot" :class="`ui-pill__dot--${item.tone}`"></span>
            {{ item.text }}
            <span v-if="item.value === value && item.count !== undefined && item.count !== null" class="ui-pill__count">{{ formatCount(item.count) }}</span>
        </button>
    </div>
</template>

<script>
// Filtro rapido em pilulas (Todas, Pendentes, Aprovadas...). A quantidade
// aparece na pilula ativa. items: [{ value, text, tone?, count? }].
export default {
    name: "UiPills",
    props: {
        value: { type: [String, Number, Boolean], default: null },
        items: { type: Array, required: true },
    },
    methods: {
        formatCount(value) {
            return Number(value || 0).toLocaleString("pt-BR");
        },
    },
};
</script>
